import { createSlice } from '@reduxjs/toolkit';
import { ISavedChat, ISavedChatSubset } from '../types';

interface ISavedChatState {
  selectedChat: ISavedChat | null;
  listOfSavedChats: ISavedChatSubset[];
}

const initialState: ISavedChatState = {
  selectedChat: null,
  listOfSavedChats: [],
};

const savedChatSlice = createSlice({
  name: 'savedChat',
  initialState,
  reducers: {
    setSelectedChat(state, action) {
      state.selectedChat = action.payload;
    },
    setSavedChatsList(state, action) {
      state.listOfSavedChats = action.payload;
    }
  },
});

export const { setSelectedChat, setSavedChatsList } = savedChatSlice.actions;
export default savedChatSlice.reducer;
